import { Component, OnInit } from '@angular/core';
import { Global } from 'src/app/shared/global';

@Component({
  selector: 'app-medicare-definition',
  templateUrl: './medicare-definition.component.html',
  styleUrls: ['./medicare-definition.component.scss']
})
export class MedicareDefinitionComponent implements OnInit {
  subTitle:string;
  bodyText: string;

  constructor(private global: Global) { }

  ngOnInit(): void {
    this.subTitle = this.global.getEduLessonObj[this.global.selectedEduCategory].lessons[this.global.selectedEduCatLesson].title;    
    this.bodyText = this.global.getEduLessonObj[this.global.selectedEduCategory].lessons[this.global.selectedEduCatLesson].content;    
  }

}
